module.exports = __webpack_public_path__ + "img/instagram.601c5559.svg";